<div class="mat-dialog-title">
  <p>FILTRO POR EMPRESA</p>
</div>

<div class="mat-dialog-content">
  <div class="form-container">
    <mat-checkbox *ngIf="showAllCompaniesOption()" [formControl]="selectAllCompaniesFormControl" (change)="onSelectAllCompanies($event)"
      >Todas as empresas</mat-checkbox
    >

    <div class="search-company-bar">
      <input type="text" placeholder="CNPJ" [(ngModel)]="filter" (keyup.enter)="onSearchCompanyFiltered()" />
      <div class="img-container" (click)="onSearchCompanyFiltered()">
        <mat-icon aria-hidden="false">search</mat-icon>
      </div>
    </div>
  </div>

  <div class="table-container">
    <div class="tb-grid th-container">
      <span class="t-header">CNPJ</span>
      <span class="t-header">Nome Fantasia</span>
      <span class="t-header">Razão Social</span>
    </div>

    <div>
      <span *ngIf="getCompanyList().length == 0" class="t-body">Nenhum empresa encontrada.</span>
    </div>

    <div *ngFor="let company of getCompanyList()" class="tb-grid tb-container">
      <!-- column 1 -->
      <mat-radio-button [id]="'radio_buttom_' + company.getFiscalNumber()" class="t-body" (change)="onSelectedCompanyChange(company)">{{
        company.getFiscalNumber() | companyFederalNumber
      }}</mat-radio-button>

      <!-- column 2 -->
      <span class="t-body text-overflow" [matTooltip]="company.getTradingName()">{{ company.getTradingName() }}</span>

      <!-- column 3 -->
      <span class="t-body text-overflow" [matTooltip]="company.getCorporateName()">{{ company.getCorporateName() }}</span>
    </div>
  </div>
</div>

<div class="mat-dialog-actions">
  <a class="cancel-btn" (click)="closeDialog()"> CANCELAR </a>

  <a class="apply-btn" (click)="applyFilter()"> APLICAR </a>
</div>
